<template>
  <div class="container">
      <!-- 查询表单 -->
      <el-input size="mini" type="number" v-model="queryForm.user_id" placeholder="请输入用户ID"></el-input>
      <el-input size="mini" type="number" v-model="queryForm.mobile_phone" placeholder="请输入用户手机号"></el-input>
      <el-select v-model="queryForm.role_type" placeholder="请选择身份" size="mini">
          <el-option v-for="item in identityOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
      </el-select>
      <el-input size="mini" type="number" v-model="queryForm.amount1" placeholder="请输入申请提现金额"></el-input>
      ——
      <el-input size="mini" type="number" v-model="queryForm.amount2" placeholder="请输入申请提现金额"></el-input>
      <el-select v-model="queryForm.status" placeholder="请选择状态" size="mini">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
      </el-select>
      <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
      <el-button type="primary" size="mini" @click="handleExport">导出</el-button>
      <el-button type="primary" size="mini" @click="openSettings">提现设置</el-button>
      <!-- 数据表格 -->
      <el-row>
          <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true" style="width: 100%; margin: 10px 0">
              <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
              <el-table-column prop="nickname" label="用户昵称" min-width="120"></el-table-column>
              <el-table-column prop="mobile_phone" label="手机号" width="130"></el-table-column>
              <el-table-column prop="role_type_text" label="身份" width="100"></el-table-column>
              <el-table-column prop="amount" label="申请提现金额" width="220"></el-table-column>
              <el-table-column prop="status_text" label="状态" width="220">
              </el-table-column>
            <el-table-column prop="created_at" label="申请时间" width="220">
            </el-table-column>
              <el-table-column label="操作" fixed="right" width="150">
                    <template #default="scope">
                        <el-button size="mini" type="text" @click="revenueList(scope.row.user_id)">流水</el-button>
                        <el-button size="mini" type="text" @click="handleEdit(scope.row)" v-if="scope.row.status == 1">通过</el-button>
                        <el-button size="mini" type="text" @click="handleDelete(scope.row)" v-if="scope.row.status == 1">拒绝</el-button>
                    </template>
                </el-table-column>
          </el-table>
      </el-row>
      <el-row>
            <div class="block">
                <el-pagination background @current-change="getList" :current-page.sync="queryForm.page" :page-size="queryForm.limit"
                               layout="total, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-row>
    <!-- 提现设置弹窗 -->
    <el-dialog title="每月提现时间设置" :visible.sync="settingsDialogVisible"  width="30%">
      <el-form :model="withdrawForm" ref="withdrawForm" label-width="100px" v-loading="settingsDialogLoading">
        <el-form-item label="开始日期" prop="start_day" :rules="[
          { required: true, message: '请输入开始日期', trigger: 'blur' },
          { type: 'number', min: 1, max: 31, message: '日期必须在1-31之间', trigger: 'blur' }
        ]">
          <el-input v-model.number="withdrawForm.start_day" type="number" placeholder="请输入开始日期 (1-31)"></el-input>
        </el-form-item>
        <el-form-item label="结束日期" prop="end_day" :rules="[
          { required: true, message: '请输入结束日期', trigger: 'blur' },
          { type: 'number', min: 1, max: 31, message: '日期必须在1-31之间', trigger: 'blur' }
        ]">
          <el-input v-model.number="withdrawForm.end_day" type="number" placeholder="请输入结束日期 (1-31)"></el-input>
        </el-form-item>
        <el-form-item>
          <span style="color: #999; font-size: 12px;">注：设置每月的提现时间段，例如 5号 到 10号，则填写 5 和 10</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveSettings">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getWithdrawList,withdrawAudit, getWithdrawConfig, saveWithdrawConfig } from "@/api/luminaryplan";
export default {
  data() {
      return {
          queryForm: {
            user_id: "",
              role_type: "",
              mobile_phone: "",
              amount1: "",
              amount2: "",
              page: 1,
              limit: 10,
          },
          registerDate: [],
          loading: false,
          identityOptions: [
                { value: '', label: "全部" },
                { value: 'city', label: "市代" },
                { value: 'courier', label: "驿站" },
                { value: 'notAgent', label: "非代理" },
            ],
            statusOptions: [
                { value: '', label: "全部" },
                { value: '1', label: "待审核" },
                { value: '2', label: "已通过" },
                { value: '3', label: "已拒绝" },
            ],
          tableData: [
          ],
          total:0,
          settingsDialogLoading: false,
          settingsDialogVisible: false,
          withdrawForm: {
            start_day: null,
            end_day: null
          },
      };
  },
  mounted() {
      this.getList();
  },
  methods: {
      revenueList(userId) {
        this.$router.push({ path: '/luminaryplan/revenue_list', query: { user_id: userId } });
      },
      handleSearch() {
          console.log("搜索参数：", this.queryForm);
          // 这里添加搜索逻辑
          this.queryForm.page = 1;
          this.getList();
      },
      handleExport() {
          console.log("导出数据");
          const params = new URLSearchParams();
          const fullUrl = window.location.origin;
          // 遍历 queryForm，只添加有值的参数
          Object.entries(this.queryForm).forEach(([key, value]) => {
            if (value !== null && value !== undefined) {
              params.append(key, value);
            }
          });
          // https://dev.backend.zhangdefenspace.com/ https://backend.zhangdefenspace.com/
          const url = `${fullUrl}/backend/activity/luminary/exportWithdrawList?${params.toString()}`;
          // window.open(url, '_blank');
          location.href = url;
      },
      handleEdit(row){
        this.$confirm('是否确认通过提现？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
          withdrawAudit({id:row.id,status:2}).then((res) => {
            if (res.code === 1) {
                this.$message.success("操作成功");
                this.getList();
            } else {
                this.$message.error(res.msg);
            }
          });
        }).catch(() => {});
      },
      handleDelete(row) {
        this.$confirm('是否确认拒绝提现？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            // 调用实际拒绝逻辑 
            withdrawAudit({id:row.id,status:3}).then((res) => {
                if (res.code === 1) {
                    this.$message.success("操作成功");
                    this.getList(); 
                }else{
                    this.$message.error(res.msg);
                }
            })
        }).catch(() => {});
      },
      getList() {
          this.loading = true;
          getWithdrawList(this.queryForm).then((res) => {
              if (res.code === 1) {
                  this.tableData = res.data.list;
                  this.total = res.data.total; 
                  this.loading = false;
              } 
          })
      },
      openSettings() {
        this.settingsDialogLoading = true;
        this.settingsDialogVisible = true;
        // 获取配置
        getWithdrawConfig().then(res => {
          if (res.code === 1 && res.data) {
            this.withdrawForm.start_day = Number(res.data.start_day);
            this.withdrawForm.end_day = Number(res.data.end_day);
            this.settingsDialogLoading = false;
          }
        });
      },
      saveSettings() {
        this.$refs.withdrawForm.validate((valid) => {
          if (valid) {
            if (this.withdrawForm.start_day > this.withdrawForm.end_day) {
              this.$message.error("开始日期不能大于结束日期");
              return;
            }
            saveWithdrawConfig(this.withdrawForm).then(res => {
              if (res.code === 1) {
                this.$message.success("设置成功");
                this.settingsDialogVisible = false;
              } else {
                this.$message.error(res.msg || "设置失败");
              }
            });
          }
        });
      }
  },
};
</script>

<style scoped>
.container {
  padding: 20px 10px;
}
.container .el-input {
  width: 200px;
  margin: 0 10px 10px;
}
.container .showAuthDialog .el-input {
  width: 300px;
}
.container .showAuthDialog .el-form-item {
  margin-bottom: 0px;
}
.el-table {
  margin-top: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}
</style>